// 导入组件
import Vue from 'vue';
import Router from 'vue-router';

const invoicingPage = () => import("@/views/myOrder/invoicingPage");
// 注册
const maintaining = () => import("@/views/maintaining");
// 注册
const register = () => import("@/views/enterpriseRegis");
// 商品列表
import goodsList from '@/views/goodsList/index_copy'
// 订单详情
const myOrderDetail = () => import("@/views/myOrder/myOrderDetail");
// // 购物车
const shoppingcart = () => import("@/views/shoppingcart/shoppingcart");

//重新发起售后
const reSaleAfter = () => import("@/views/myOrder/reSaleAfter");

//发票列表
const invoiceList = () => import("@/views/myOrder/invoiceList");

// 登录
import login from '@/views/login';
// 无权限访问
const erroPage = () => import("@/views/erroPage");

// const testPage=()=>import("@/views/testPage");

// 商品详情
const goodsDetail = () => import("@/views/goodsList/goodsDetail");


// 找回密码
const retrievePassword = () => import("@/views/retrievePassword");

const initialPasswordSet = () => import("@/views/initialPasswordSet");

// 用户协议
const userAgreement = () => import("@/views/userAgreement");


// 首页
import index from '@/views/index';
/**
 * 基础菜单
 */
// 商品管理
const Goods = () => import("@/views/goods/Goods");

// 机器信息管理
const Machine = () => import("@/views/machine/Machine");

// 货道信息管理
const MachineAisle = () => import("@/views/machine/MachineAisle");

/**
 * 订单管理
 */
// 交易订单
const Order = () => import("@/views/pay/Order");

/**
 * 系统管理
 */
// 用户管理
const user = () => import("@/views/system/user");

// 菜单管理
const Module = () => import("@/views/system/Module");

// 角色管理
const Role = () => import("@/views/system/Role");

// 公司管理
const Dept = () => import("@/views/system/Dept");

// 系统环境变量
const Variable = () => import("@/views/system/Variable");

// 权限管理
const Permission = () => import("@/views/system/Permission");

/**
 * 支付管理
 */
// 支付配置信息
const MachineConfig = () => import("@/views/machine/MachineConfig");

// 支付配置
const Config = () => import("@/views/pay/Config");

/**
 * 数据监控
 */
// 监控查询
const druidLogin = () => import("@/views/druid/login");

// 图表界面
const statistics = () => import("@/views/charts/statistics");

// 限时折扣
const limitDiscounts = () => import("@/views/limitDiscounts/index");

// 秒杀
const spike = () => import("@/views/spike/index");

// 红包页面
const redenvelopes = () => import("@/views/redenvelopes/index");

// 品牌
const brand = () => import("@/views/brand/index");

// 商家入驻 系列
const welcomesystem = () => import("@/views/merchantSettled/welcomesystem");
const merchantTypeSelect = () => import("@/views/merchantSettled/merchantTypeSelect");
const merchantApply = () => import("@/views/merchantSettled/merchantApply");
const merchantForm = () => import("@/views/merchantSettled/merchantForm");
const merchantStatus = () => import("@/views/merchantSettled/merchantStatus");
const merchantpayFor = () => import("@/views/merchantSettled/menchantpayFor");
const storeOpen = () => import("@/views/merchantSettled/storeOpen");

// 购物车
const orderDetail = () => import("@/views/shoppingcart/orderDetail");
const orderNow = () => import("@/views/shoppingcart/orderNow");
const orderNowMorePay = () => import("@/views/shoppingcart/orderNowMorePay");
const wxERweima = () => import("@/views/shoppingcart/wxERweima");


// 头部客户服务的 相关文章分类
const serviceArticle = () => import("@/views/serviceArticle/index");
const siteHelp = () => import("@/views/serviceArticle/siteHelp");  // 站点帮助
const siteHelpDetail = () => import("@/views/serviceArticle/siteHelpDetail"); // 站点帮助详情

// 我的订单
const myOrder = () => import("@/views/myOrder/index");
const myOrderRight = () => import("@/views/myOrder/myOrder");
const goodsAppraisal = () => import("@/views/myOrder/goodsAppraisal");
const orderAppraisal = () => import("@/views/myOrder/evaluationePage/orderAppraisal");
const gotoEvaluation = () => import("@/views/myOrder/evaluationePage/gotoEvaluation");
const evaluationDetail = () => import("@/views/myOrder/evaluationePage/evaluationDetail");
const pointsOrder = () => import("@/views/myOrder/pointsOrder");
const myRefund = () => import("@/views/myOrder/myRefund");
const mySalesman = () => import("@/views/myOrder/mySalesman");
const afetrSuccess = () => import("@/views/myOrder/afetrSuccess");


// 关注中心
const goodsCollection = () => import("@/views/myOrder/attentionCenter/goodsCollection"); // 商品收藏
const myFooter = () => import("@/views/myOrder/attentionCenter/myFooter");  // 我的足迹
const shopCollection = () => import("@/views/myOrder/attentionCenter/shopCollection");  // 店铺收藏

// 支付成功 
const paySuccess = () => import("@/views/paySuccess");

// 个人中心
// import myInfo from '@/views/myOrder/myCenter/myInfo' // 账号安全
// import myInfo from '@/views/myOrder/myCenter/myInfo' // 绑定授权
const myInfomation = () => import("@/views/myOrder/myCenter/myInfo");
const subAccount = () => import("@/views/myOrder/myCenter/subAccount");
const rebate = () => import("@/views/myOrder/myCenter/rebate");
const address = () => import("@/views/myOrder/myCenter/address");
const myStripe = () => import("@/views/myOrder/myCenter/myStripe");
const myAppay = () => import("@/views/myOrder/myCenter/myAppay");
const stripeDetails = () => import("@/views/myOrder/myCenter/stripeDetails");

// 客户服务
const refund = () => import("@/views/myOrder/customerService/refund");  // 我的售后
const refundDetail = () => import("@/views/myOrder/refundDetail");  // 退款退货
const refundDetail2 = () => import("@/views/myOrder/refundDetail2");  // 退款退货
const consultation = () => import("@/views/myOrder/customerService/consultation"); // 商品咨询
const invoice = () => import("@/views/myOrder/customerService/invoice"); // 退款退货

// 财产中心
const myRedPack = () => import("@/views/myOrder/propertyCenter/myRedPack");
const myScores = () => import("@/views/myOrder/propertyCenter/myScores");

// 首页main
import main from '@/views/dashboard/main';
// 首页-店铺街
const store = () => import("@/views/store/store");
const messageBox = () => import("@/views/messageBox");

// import shopStore from '@/views/store/shopStore';
const shopStore = () => import("@/views/store/storeHome");


/** 供应商 **/
// 首页
const supplier = () => import("@/views_supplier/index");

// 首页main
const main_supplier = () => import("@/views_supplier/dashboard/main");

// 首页-店铺街
const store_supplier = () => import("@/views_supplier/store/store");

// import shopStore_supplier from '@/views_supplier/store/shopStore';
const shopStore_supplier = () => import("@/views_supplier/store/storeHome");

// 商品列表
const goodsList_supplie = () => import("@/views_supplier/goodsList/index");

// 联系我们
// import contactUs from '@/views_supplier/contactUs/contactUs';
// 商品详情
const goodsDetail_supplie = () => import("@/views_supplier/goodsList/goodsDetail");

// 购物车
const shoppingcart_supplie = () => import("@/views_supplier/shoppingcart/shoppingcart");

// 下单
const orderDetail_supplie = () => import("@/views_supplier/shoppingcart/orderDetail");

/** 供应商 **/
// 我的订单
// 个人中心
// import address_supplier from '@/views_supplier/myOrder/myCenter/address'  // 收货地址
// 财产中心
// import myRedPack_supplier from '@/views_supplier/myOrder/propertyCenter/myRedPack'  // 我的红包
// import goodsAppraisal_supplier from '@/views_supplier/myOrder/goodsAppraisal'
const myOrder_supplier = () => import("@/views_supplier/myOrder/index");
const myOrderRight_supplier = () => import("@/views_supplier/myOrder/myOrder");
const myOrderDetail_supplier = () => import("@/views_supplier/myOrder/myOrderDetail");
const myRefund_supplier = () => import("@/views_supplier/myOrder/myRefund");


/** 积分商城 **/
const pointMall = () => import("@/views/pointMall/pointMall");

// 积分商城 积分商品详情
const pointsProDetails = () => import("@/views/pointMall/pointsProDetails");

/** 站点导航 **/
const siteNavigation = () => import("@/views/siteNavigation/siteNavigation");
const userCenter = () => import("@/views/siteNavigation/userCenter");
const paymentCenter = () => import("@/views/siteNavigation/paymentCenter");
const payment = () => import("@/views/siteNavigation/payment");

const test = () => import("@/views/test.vue");

// 启用路由
Vue.use(Router);

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

// 导出路由 
export default new Router({
  // mode: 'history',  //去掉url中的#
  scrollBehavior(to, from, savePosition) {
    if (savePosition) {
      return savePosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: '首页',
      component: index,
      iconCls: 'el-icon-tickets',
      hidden: true,
      meta: {
        requireAuth: false
      },
      children: [
        {
          path: '/',
          name: '嵌套在首页',
          component: main,
          redirect: '/goodsList',
          meta: {
            requireAuth: false
          }
        }, {
          path: '/store',
          name: '店铺街',
          component: store,
          meta: {
            requireAuth: false
          }
        },
        {
          path: '/shopStore',
          name: '店铺详情',
          component: shopStore,
          meta: {
            requireAuth: false
          }
        },
        {
          path: '/shoppingcart',
          name: '购物车',
          component: shoppingcart,
          hidden: true,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/orderDetail',
          name: '购物车订单',
          component: orderDetail,
          hidden: true,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/orderNow',
          name: '购物车付款',
          component: orderNow,
          hidden: true,
          meta: {
            requireAuth: true,
          }
        }, {
          path: '/orderNowMorePay',
          name: '购物车付款',
          component: orderNowMorePay,
          hidden: true,
          meta: {
            requireAuth: true,
          }
        },
        {
          path: '/paySuccess',
          name: '支付成功',
          component: paySuccess,
          hidden: true,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/redenvelope',
          name: '红包',
          component: redenvelopes,
          hidden: true,
          meta: {
            requireAuth: false
          }
        }, {
          path: '/brand',
          name: '品牌',
          component: brand,
          hidden: true,
          meta: {
            requireAuth: false
          }
        }, {
          path: `/goodsList`,
          name: '商品列表',
          component: goodsList,
          hidden: true,
          meta: {
            requireAuth: false
          }
        }, {
          path: '/goodsDetail',
          name: '商品详情',
          component: goodsDetail,
          hidden: true,
          meta: {
            requireAuth: false
          }
        },
        {
          path: '/pointMall',
          name: '积分商城',
          component: pointMall,
          hidden: true,
          meta: {
            requireAuth: false
          }
        },
        // pointsProDetails
        {
          path: '/pointsProDetails',
          name: '积分商城',
          component: pointsProDetails,
          hidden: true,
          meta: {
            requireAuth: false
          }
        },
        {
          path: '/limitDiscounts',
          name: '限时折扣',
          component: limitDiscounts,
          hidden: true,
          meta: {
            requireAuth: false
          }
        },
        {
          path: '/spike',
          name: '秒杀',
          component: spike,
          hidden: true,
          meta: {
            requireAuth: false
          }
        },
        {
          path: '/gotoEvaluation',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
          name: '去评价',
          component: gotoEvaluation
        },
        {
          path: '/orderAppraisal',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
          name: '订单评价',
          component: orderAppraisal //orderAppraisal
        },
        {
          path: '/evaluationDetail',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
          name: '商品评价详情',
          component: evaluationDetail
        },
        {
          path: '/serviceArticle',
          name: '文章分类',
          redirect: '/siteHelp',
          component: serviceArticle,
          hidden: true,
          meta: {
            requireAuth: true
          },
          children: [
            {
              path: '/siteHelp',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
              name: '站点帮助',
              component: siteHelp,
              meta: {
                requireAuth: true
              },

            },
            {
              path: '/siteHelpDetail',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
              name: '站点帮助详情',
              component: siteHelpDetail,
              meta: {
                requireAuth: true
              },

            },
          ]
        },
        {
          path: '/myOrder',
          name: '我的订单',
          redirect: '/myOrderRight',
          component: myOrder,
          hidden: true,
          meta: {
            requireAuth: true
          },
          children: [
            {
              path: '/mySalesman',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
              name: '我的业务员',
              component: mySalesman,
              meta: {
                requireAuth: true
              },
            },
            {
              path: '/afetrSuccess',
              name: '售后申请提交成功',
              component: afetrSuccess,
              meta: {
                requireAuth: true,
              },
            },
            {
              path: '/myOrderRight',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
              name: '我的订单',
              component: myOrderRight,
              meta: {
                requireAuth: true,
              },
            },
            {
              path: '/invoiceList',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
              name: '发票管理',
              component: invoiceList,
              meta: {
                requireAuth: true,
              },
            },
            {
              path: '/invoicingPage',
              name: '申请开票',
              component: invoicingPage,
              meta: {
                requireAuth: true
              }
            },
            {
              path: '/myOrderDetail',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
              name: '订单详情',
              component: myOrderDetail,
              meta: {
                requireAuth: true,
              }
            },
            {
              path: '/myRefund',//退款页面 付完钱可以申请退款页面
              name: '退款编写',
              component: myRefund,
              meta: {
                requireAuth: true,
              }
            },
            {
              path: '/refundDetail',//退款页面 付完钱可以申请退款页面
              name: '退款详情',
              component: refundDetail,
              meta: {
                requireAuth: true
              }
            },
            {
              path: '/reSaleAfter',
              name: '重新发起售后',
              component: reSaleAfter,
              meta: {
                requireAuth: true
              }
            },
            {
              path: '/refundDetail2',//退款页面 付完钱可以申请退款页面, 从订单页面进入的退款详情可以展示多个退款单
              name: '退款详情2',
              component: refundDetail2,
              meta: {
                requireAuth: true,
              }
            },
            {
              path: '/goodsAppraisal',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
              name: '商品评价',
              component: goodsAppraisal
            },
            {
              path: '/pointsOrder',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
              name: '积分订单',
              component: pointsOrder
            },
            {
              path: '/goodsCollection',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
              name: '商品收藏',
              component: goodsCollection,
              meta: {
                requireAuth: true
              },
            },
            {
              path: '/shopCollection',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
              name: '店铺收藏',
              component: shopCollection
            },
            {
              path: '/myFooter',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
              name: '我的足迹',
              component: myFooter,
              meta: {
                requireAuth: true
              },
            },
            {
              path: '/myInfomation',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
              name: '个人信息',
              component: myInfomation,
              meta: {
                requireAuth: true
              },
            },
            {
              path: '/subAccount',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
              name: '子账号管理',
              component: subAccount,
              meta: {
                requireAuth: true
              },
            },
            {
              path: '/rebate',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
              name: '返利管理',
              component: rebate,
              meta: {
                requireAuth: true
              },
            },
            {
              path: '/address',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
              name: '收货地址',
              component: address,
              meta: {
                requireAuth: true
              },
            },
            {
              path: '/myStripe',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
              name: '我的授信',
              component: myStripe,
              meta: {
                requireAuth: true,
              }
            },
            {
              path: '/myAppay',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
              name: '我的授信',
              component: myAppay,
              meta: {
                requireAuth: true
              }
            },
            {
              path: '/stripeDetails',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
              name: '我的授信',
              component: stripeDetails,
              meta: {
                requireAuth: true,
              }
            },
            {
              path: '/refund',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
              name: '我的售后',
              component: refund,
              meta: {
                requireAuth: true
              }
            },
            {
              path: '/invoice',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
              name: '发票管理',
              component: invoice
            },
            {
              path: '/consultation',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
              name: '商品咨询',
              component: consultation
            },
            {
              path: '/myScores',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
              name: '我的积分',
              component: myScores,
              meta: {
                requireAuth: true
              }
            },
            {
              path: '/myRedPack',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
              name: '我的红包',
              component: myRedPack,
              meta: {
                requireAuth: true
              }
            }
          ]
        },
      ]
    },
    {
      path: '/tt',
      component: test,
      hidden: true,
      meta: {
        requireAuth: false
      },
    },
    {
      path: '/welcomesystem',
      name: '商家入驻欢迎',
      component: welcomesystem,
      hidden: true,
      meta: {
        requireAuth: true
      }
    }, {
      path: '/merchantTypeSelect',
      name: '商家入驻选择',
      component: merchantTypeSelect,
      hidden: true,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/register',
      name: '注册',
      component: register,
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/merchantApply',
      name: '商家入驻协议',
      component: merchantApply,
      hidden: true,
      meta: {
        requireAuth: true
      }
    }, {
      path: '/merchantForm',
      name: '商家入驻表单',
      component: merchantForm,
      hidden: true,
      meta: {
        requireAuth: true
      }
    }, {
      path: '/merchantStatus',
      name: '商家入驻平台审核',
      component: merchantStatus,
      hidden: true,
      meta: {
        requireAuth: true
      }
    }, {
      path: '/merchantpayFor',
      name: '商家入驻平台交费',
      component: merchantpayFor,
      hidden: true,
      meta: {
        requireAuth: true
      }
    }, {
      path: '/storeOpen',
      name: '商家入驻店铺开通',
      component: storeOpen,
      hidden: true,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/login',
      name: '登录',
      component: login,
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/erroPage', // 无权访问页面
      name: '404',
      component: erroPage,
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/messageBox',
      name: '消息盒子',
      component: messageBox,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/maintaining',
      name: '维护中',
      component: maintaining,
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/retrievePassword',
      name: '找回密码',
      component: retrievePassword,
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/initialPasswordSet',
      name: '修改登录初始密码',
      component: initialPasswordSet,
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/userAgreement',
      name: '用户协议',
      component: userAgreement,
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/wxERweima',
      name: '微信支付二维码',
      component: wxERweima,
      hidden: true,
      meta: {
        requireAuth: true
      }
    },
    /** 站点导航 */
    {
      path: '/siteNavigation',
      name: '站点导航首页',
      component: siteNavigation,
      iconCls: 'el-icon-tickets',
      redirect: '/userCenter',
      hidden: true,
      meta: {
        requireAuth: true
      },
      children: [
        {
          path: '/userCenter',
          name: '用户中心',
          component: userCenter,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/paymentCenter',
          name: '支付中心',
          component: paymentCenter,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/payment',
          name: '授信还款',
          component: payment,
          meta: {
            requireAuth: true,
          }
        },
      ]
    },
    // 以下 批发市场 供应商 首页
    {
      path: '/supplier',
      name: '供应商首页',
      component: supplier,
      iconCls: 'el-icon-tickets',
      redirect: '/supplierIndex',
      hidden: true,
      meta: {
        requireAuth: false
      },
      children: [
        {
          path: '/supplierIndex',
          name: '供应商嵌套在首页',
          component: main_supplier,
          meta: {
            requireAuth: false
          }
        }, {
          path: '/store_supplier',
          name: '店铺馆',
          component: store_supplier,
          meta: {
            requireAuth: false
          }
        },
        {
          path: '/shopStore_supplier',
          name: '店铺详情',
          component: shopStore_supplier,
          meta: {
            requireAuth: false
          }
        },
        {
          path: '/goodsList_supplier',
          name: '商品列表',
          component: goodsList_supplie,
          hidden: true,
          meta: {
            requireAuth: false
          }
        },
        // {
        //     path: '/contactUs',
        //     name: '联系我们',
        //     component: contactUs,
        //     hidden: true,
        //     meta: {
        //         requireAuth: false
        //     }
        // }, 
        {
          path: '/goodsDetail_supplie',
          name: '商品详情',
          component: goodsDetail_supplie,
          hidden: true,
          meta: {
            requireAuth: false
          }
        },

        // 与普通供应商的页面一样(公共页面)
        // {
        //     path: '/shoppingcart',
        //     name: '购物车',
        //     component: shoppingcart,
        //     hidden: true,
        //     meta: {
        //         requireAuth: true
        //     }
        // },
        // {
        //     path: '/orderDetail',
        //     name: '购物车订单',
        //     component: orderDetail,
        //     hidden: true,
        //     meta: {
        //         requireAuth: true
        //     }
        // },
        // {
        //     path: '/myOrder_supplier',
        //     name: '我的订单',
        //     redirect: '/myOrderRight__supplier',
        //     component: myOrder,
        //     hidden: true,
        //     meta: {
        //         requireAuth: true
        //     },
        //     children: [
        //         {
        //           path: '/myOrderRight__supplier',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
        //           name: '我的订单',
        //           component: myOrderRight,
        //           meta: {
        //             requireAuth: true
        //         },
        //         },
        //         {
        //             path: '/myOrderDetail_supplier',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
        //             name: '订单详情',
        //             component: myOrderDetail
        //         },
        //         {
        //             path: '/myRefund_supplier',//退款页面 付完钱可以申请退款页面
        //             name: '订单详情',
        //             component: myRefund
        //         },                    
        //         {
        //             path: '/goodsAppraisal_supplier',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
        //             name: '商品评价',
        //             component: goodsAppraisal
        //         },
        //         {
        //           path: '/pointsOrder_supplier',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
        //           name: '商品积分',
        //           component: pointsOrder
        //         },
        //         {
        //             path: '/goodsAppraisal_supplier',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
        //             name: '商品评价',
        //             component: goodsAppraisal
        //         },
        //         {
        //           path: '/pointsOrder_supplier',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
        //           name: '商品积分',
        //           component: pointsOrder
        //         },
        //         {
        //             path: '/address_supplier',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
        //             name: '收货地址',
        //             component: address
        //         },
        //         {
        //           path: '/myRedPack_supplier',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
        //           name: '我的红包',
        //           component: myRedPack
        //         }
        //       ]
        // },


      ]
    },
    // {
    //     path: '/supplier',
    //     name: '供应商首页',
    //     component: supplier,
    //     iconCls: 'el-icon-tickets',
    //     redirect: '/supplierIndex',
    //     hidden: true,
    //     meta: {
    //         requireAuth: false
    //     },
    //     children: [
    //          {
    //             path: '/supplierIndex',
    //             name: '供应商嵌套在首页',
    //             component: main_supplier,
    //             meta: {
    //                 requireAuth: false
    //             }
    //         }, {
    //             path: '/store_supplier',
    //             name: '店铺馆',
    //             component: store_supplier,
    //             meta: {
    //                 requireAuth: false
    //             }
    //         },
    //         {
    //             path: '/goodsList_supplier',
    //             name: '商品列表',
    //             component: goodsList_supplie,
    //             hidden: true,
    //             meta: {
    //                 requireAuth: false
    //             }
    //         },
    //         {
    //             path: '/contactUs',
    //             name: '联系我们',
    //             component: contactUs,
    //             hidden: true,
    //             meta: {
    //                 requireAuth: false
    //             }
    //         }, 
    //         {
    //             path: '/goodsDetail_supplie',
    //             name: '商品详情',
    //             component: goodsDetail_supplie,
    //             hidden: true,
    //             meta: {
    //                 requireAuth: false
    //             }
    //         },
    //         {
    //             path: '/shoppingcart_supplie',
    //             name: '购物车',
    //             component: shoppingcart_supplie,
    //             hidden: true,
    //             meta: {
    //                 requireAuth: true
    //             }
    //         },
    //         {
    //             path: '/orderDetail_supplie',
    //             name: '购物车订单',
    //             component: orderDetail_supplie,
    //             hidden: true,
    //             meta: {
    //                 requireAuth: true
    //             }
    //         },
    //         {
    //             path: '/myOrder_supplier',
    //             name: '我的订单',
    //             redirect: '/myOrderRight_supplier',
    //             component: myOrder_supplier,
    //             hidden: true,
    //             meta: {
    //                 requireAuth: true
    //             },
    //             children: [
    //                 {
    //                   path: '/myOrderRight_supplier',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
    //                   name: '我的订单',
    //                   component: myOrderRight_supplier,
    //                   meta: {
    //                     requireAuth: true
    //                 },
    //                 },
    //                 {
    //                     path: '/myOrderDetail_supplier',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
    //                     name: '订单详情',
    //                     component: myOrderDetail_supplier
    //                 },
    //                 {
    //                     path: '/myRefund_supplier',//退款页面 付完钱可以申请退款页面
    //                     name: '订单详情',
    //                     component: myRefund_supplier
    //                 },                    
    //                 {
    //                     path: '/goodsAppraisal_supplier',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
    //                     name: '商品评价',
    //                     component: goodsAppraisal_supplier
    //                 },
    //                 {
    //                   path: '/pointsOrder_supplier',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
    //                   name: '商品积分',
    //                   component: pointsOrder_supplier
    //                 },
    //                 {
    //                     path: '/goodsAppraisal_supplier',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
    //                     name: '商品评价',
    //                     component: goodsAppraisal_supplier
    //                 },
    //                 {
    //                   path: '/pointsOrder_supplier',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
    //                   name: '商品积分',
    //                   component: pointsOrder_supplier
    //                 },
    //                 {
    //                     path: '/address_supplier',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
    //                     name: '收货地址',
    //                     component: address
    //                 },
    //                 {
    //                   path: '/myRedPack_supplier',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
    //                   name: '我的红包',
    //                   component: myRedPack
    //                 }
    //               ]
    //         },
    //     ]
    // },
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js